import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './AuthPages.css';

export default function VerifyEmailPage() {
  const { verifyEmail } = useAuth();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token found. Please use the link from your email.');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const data = await verifyEmail(token);
        if (!cancelled) {
          setStatus('success');
          setMessage(data.message || 'Email verified successfully!');
        }
      } catch (err) {
        if (!cancelled) {
          setStatus('error');
          setMessage(err.response?.data?.detail || 'Verification failed. The link may have expired.');
        }
      }
    })();

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">AI Broker</div>
        <h1>Email verification</h1>

        {status === 'verifying' && (
          <div className="auth-loading">
            <div className="spinner" />
            <p>Verifying your email…</p>
          </div>
        )}

        {status === 'success' && <div className="auth-success">{message}</div>}
        {status === 'error' && <div className="auth-error">{message}</div>}

        <p className="auth-footer">
          <Link to="/login">Go to sign in</Link>
        </p>
      </div>
    </div>
  );
}
